module.exports = __webpack_public_path__ + "static/media/cdb13.fb979503.png";